export default {
  user: {},
  tempUser: {},
  displayAuthorisationResponseDialog: false,
  displayDeclineInvoiceReasonDialog: false,
  verifier: '',
};
